import type React from 'react';

import { type Location, useLocation, useParams } from 'react-router';

import Layout from '@/layouts/private/Layout.tsx';
import { type RouteStateModel } from '@/model/RouteState.model.ts';

interface Props {
  component: React.FC<{ route: RouteStateModel }>;
}

/**
 * Element of lazily loaded leaf routes (OCD-303): the route `lazy` resolves
 * the view module, this wrapper keeps the `route` prop contract that views
 * used to receive via Layout.
 */
export const RoutedView: React.FC<Props> = ({ component: View }) => {
  const params = useParams();
  const location = useLocation() as Location<Record<string, unknown>>;

  const route: RouteStateModel = {
    location,
    params,
  };

  return <Layout component={View} route={route} />;
};
